export default __webpack_public_path__ + "static/media/pattern.9b2b2bc5.webp";